import { render, staticRenderFns } from "./TestWidgetWithIcon.vue?vue&type=template&id=37bde37c&"
import script from "./TestWidgetWithIcon.vue?vue&type=script&lang=js&"
export * from "./TestWidgetWithIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports